import { render, staticRenderFns } from "./LiveClasses.vue?vue&type=template&id=e3dbf984&scoped=true&"
import script from "./LiveClasses.vue?vue&type=script&lang=js&"
export * from "./LiveClasses.vue?vue&type=script&lang=js&"
import style0 from "./LiveClasses.vue?vue&type=style&index=0&id=e3dbf984&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e3dbf984",
  null
  
)

component.options.__file = "LiveClasses.vue"
export default component.exports